<template>
  <div id="box">

    <el-table :data="tableData1" border>
      <el-table-column prop="name" label=" " :width="remtopx(0.53)">
      </el-table-column>
      <el-table-column prop="col1" label="最大值" :width="remtopx(0.34)">
      </el-table-column>
      <el-table-column prop="col2" label="最大值ID" :width="remtopx(0.34)">
      </el-table-column>
      <el-table-column prop="col3" label="最小值" :width="remtopx(0.34)">
      </el-table-column>
      <el-table-column prop="col4" label="最小值ID" :width="remtopx(0.34)">
      </el-table-column>
      <el-table-column prop="col5" label="极差值" :width="remtopx(0.34)">
      </el-table-column>
      <el-table-column prop="col5" label="平均值" :width="remtopx(0.34)">
      </el-table-column>
    </el-table>

    <div class="status">
      <div class="l">
        <div class="open"></div>
        <div class="text">堆主正接触器</div>
      </div>
      <div class="r">
        <div class="close"></div>
        <div class="text">堆主负接触器</div>
      </div>
    </div>
  </div>
</template>

<script>
// import img from "../img/6.png";
// import cfg from "./config.js";
export default {
  props: [],
  data() {
    return {

      tableData1: [
        {
          name: "电压(V)",
          col1: 3.558,
          col2: 3.122,
          col3: 0.255,
          col4: 1,
          col5: 1,
        },
        {
          name: "湿度(℃)",
          col1: 1,
          col2: 15.6,
          col3: 3,
          col4: 1,
          col5: 1,
        },
        {
          name: "单体编号",
          col1: 1,
          col2: 15.6,
          col3: 3,
          col4: 1,
          col5: 1,
        },
      ],
    };
  },
  methods: {
    remtopx(rem) {
      return Math.floor((this._routerRoot.rem * rem) / 1.5);
    },
  },
};
</script>

<style lang="scss" scoped>
>>> .el-table {
  margin-top: 0.05rem;
  background-color: rgba(0, 0, 0, 0);
  border-right: 1px solid;
  border-color:  rgba($color: #0f69ca, $alpha: 0.12) !important;
}
>>> table {
  width: 100% !important;
}
>>> .el-table * {
  font-size: 0.07rem;
  color: #151a86;
  font-weight: 500;
  background: rgba($color: #000000, $alpha: 0) !important;
  border-color:  rgba($color: #0f69ca, $alpha: 0.12) !important;
}
>>> .el-table .el-table__header-wrapper {
  background-color: rgba($color: #0f69ca, $alpha: 0.05) !important;
}

>>> .el-table .el-table__row {
  border-right: 1px solid  rgba($color: #0f69ca, $alpha: 0.12) !important;
}
>>> .el-table__cell:first-child {
  border-right: 1px solid  rgba($color: #0f69ca, $alpha: 0.12) !important;
}
>>> .el-table__body .el-table__cell:first-child {
  background-color: rgba($color: #0f69ca, $alpha: 0.05) !important;
}
>>> .el-table__cell {
  border-right: none;
  text-align: center;
  height: 0.12rem !important;
  line-height: 0.12rem !important;
  padding: 0 0 0 0 !important;
}
>>> .cell {
  display: inline;
  line-height: 0.12rem;
  padding: 0 0 0 0 !important;
  zoom: 0.8;
  white-space: nowrap;
  overflow: inherit;
}
>>> .el-table--border::after {
  display: none;
}
>>> .el-table::before {
  display: none;
}

#box {
  width: 1.8688rem;
  height: 0.9rem;
  // background-image: url(../img/6.png);
  background-size: 100% 100%;
  padding-top: 0.03rem;
}

.status {
  width: 1.07rem;
  margin-top: 0.05rem;
  margin-left: 0.28rem;
  .l {
    float: left;
    width: 0.28rem;
  }
  .r {
    float: right;
    width: 0.28rem;
  }
  .text {
    width: 0.5rem;
    color: #0f69ca;
    font-size: 0.01rem;
    margin-top: 0.02rem;
   white-space: nowrap!important;
    overflow: inherit!important;
  }
  .open {
    width: 0.28rem;
    height: 0.15rem;
    background-image: url(../img/open.png);
    background-size: 100% auto;
    background-position: center bottom;
    background-repeat: no-repeat;
  }
  .close {
    width: 0.28rem;
    height: 0.15rem;
    background-image: url(../img/close.png);
    background-size: 100% auto;
    background-position: center bottom;
    background-repeat: no-repeat;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/webgl/ui/data/cu.vue